import CircularProgress from '@material-ui/core/CircularProgress';
import aspireLogo from '../../../../assets/img/aspire-logo.png';
import './FeedbackLoading.scss';

const FeedbackLoading = ({ message = 'Loading your feedback…' }) => {
  return (
    <div className="feedbackLoadingPage" role="status" aria-live="polite">
      <div className="feedbackLoadingBackdrop" aria-hidden="true" />
      <div className="feedbackLoadingCard">
        <img src={aspireLogo} alt="Aspire" className="feedbackLoadingBrand" />
        <CircularProgress size={36} thickness={4} className="feedbackLoadingSpinner" />
        <p className="feedbackLoadingMessage">{message}</p>
      </div>
    </div>
  );
};

export default FeedbackLoading;
